import type { ElementType, RefObject } from 'react';
import { useButton } from 'react-aria';
import type { AriaButtonOptions } from 'react-aria';

/**
 * If we dont add draggable react-aria prevents default so the element cant be dragged.
 */
export function useDraggableButton(
  props: AriaButtonOptions<ElementType>,
  ref: RefObject<Element | null>,
) {
  const button = useButton(props, ref as RefObject<Element>);
  // https://github.com/adobe/react-spectrum/blob/6434e08b4ab3585a993aee598d1ab5237b261576/packages/%40react-aria/interactions/src/usePress.ts#L767
  // @ts-expect-error -- react-aria buttonProps typing does not expose draggable, but drag behavior requires it.
  // eslint-disable-next-line react-hooks/immutability
  button.buttonProps.draggable = true;

  return button;
}
